/**
 * Variant Metafield Section – uppdaterar innehållet när variant byts.
 * Använder HTML som product-info redan hämtat (samma som pris/SKU uppdateras med).
 */
if (!customElements.get('variant-metafield-section')) {
  customElements.define(
    'variant-metafield-section',
    class VariantMetafieldSection extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }

      handleVariantChange(event) {
        const { variant, html } = event?.data || {};
        if (!variant) return;

        if (html) {
          this.updateFromHtml(html);
        } else {
          this.updateFromFetch(variant.id);
        }
      }

      updateFromHtml(html) {
        const doc = html instanceof Document ? html : new DOMParser().parseFromString(html, 'text/html');
        const sections = doc.querySelectorAll(`[data-section-id="${this.sectionId}"]`);
        let newContent = null;
        sections.forEach((el) => {
          const inner = el.querySelector(
            '.variant-metafield-section__inner, .page-width, .page-width--full'
          );
          if (inner && inner.innerHTML.trim() !== '') newContent = inner;
        });
        if (!newContent) return;
        const currentContent = this.querySelector(
          '.variant-metafield-section__inner, .page-width, .page-width--full'
        );
        if (currentContent) currentContent.innerHTML = newContent.innerHTML;
      }

      updateFromFetch(variantId) {
        const url = `${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`;
        this.style.opacity = '0';

        fetch(url)
          .then((res) => res.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            this.updateFromHtml(doc);
          })
          .catch(() => {})
          .finally(() => {
            this.style.opacity = '1';
          });
      }
    }
  );
}
